module.exports = __webpack_public_path__ + "static/media/muuve_logo.4894ae8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/muuve_logo.png
// module id = 2601
// module chunks = 0